var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1934",
    "data-name": "Grupo 1934",
    transform: "translate(-4131 21815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "information",
    transform: "translate(4131 -21815)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1929",
    "data-name": "Grupo 1929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1928",
    "data-name": "Grupo 1928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3252",
    "data-name": "Trazado 3252",
    d: "M10.5,0A10.5,10.5,0,1,0,21,10.5,10.494,10.494,0,0,0,10.5,0Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1931",
    "data-name": "Grupo 1931",
    transform: "translate(9.68 8.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1930",
    "data-name": "Grupo 1930"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3253",
    "data-name": "Trazado 3253",
    style: {
      fill: "#fff"
    },
    d: "M236.82,214.33a.82.82,0,0,0-.82.82v5.283a.82.82,0,1,0,1.641,0V215.15A.82.82,0,0,0,236.82,214.33Z",
    transform: "translate(-236 -214.33)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1933",
    "data-name": "Grupo 1933",
    transform: "translate(9.393 5.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1932",
    "data-name": "Grupo 1932"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_52",
    "data-name": "Elipse 52",
    cx: 1.107,
    cy: 1.107,
    r: 1.107,
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.328358209c597a677d11d2d4234d5eab.svg";
export { ForwardRef as ReactComponent };